import { render, staticRenderFns } from "./StreakPopup.vue?vue&type=template&id=27a53296&scoped=true&"
import script from "./StreakPopup.vue?vue&type=script&lang=ts&"
export * from "./StreakPopup.vue?vue&type=script&lang=ts&"
import style0 from "./StreakPopup.vue?vue&type=style&index=0&id=27a53296&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a53296",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('27a53296', component.options)
    } else {
      api.reload('27a53296', component.options)
    }
    module.hot.accept("./StreakPopup.vue?vue&type=template&id=27a53296&scoped=true&", function () {
      api.rerender('27a53296', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/components/header/StreakPopup.vue"
export default component.exports